/* ============================================================================
   Zohanify — Client Portal behaviour
   Views are all rendered server-side by sections/zh-dashboard.liquid; this file
   only switches between them, drives the mobile drawer, and filters the tables.
   No framework, no fetch — everything it needs is already in the DOM.
   ========================================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-zhd]');
  if (!root) return;

  var views = root.querySelectorAll('[data-zhd-view]');
  var navItems = root.querySelectorAll('[data-zhd-nav]');
  var sidebar = root.querySelector('[data-zhd-sidebar]');
  var scrim = root.querySelector('[data-zhd-scrim]');
  var burger = root.querySelector('[data-zhd-burger]');
  var titleEl = root.querySelector('[data-zhd-title]');
  var subEl = root.querySelector('[data-zhd-subtitle]');

  var COPY = {
    dashboard: ['Dashboard', 'Here is where every project stands today.'],
    orders: ['Orders', 'Every order, its status and how far along it is.'],
    order: ['Order details', 'Stage by stage, what is done and what is pending.'],
    tracking: ['Order Tracking', 'Follow an order through each stage.'],
    settings: ['Settings', 'Your account and portal preferences.'],
    support: ['Request Support', 'Tell us what you need — we reply fast.']
  };

  /* ------------------------------------------------------------- drawer */
  function setDrawer(open) {
    root.classList.toggle('is-drawer-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    // The drawer covers the whole viewport on phones — stop the page behind it
    // from scrolling underneath.
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { setDrawer(!root.classList.contains('is-drawer-open')); });
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
  var drawerClose = root.querySelector('[data-zhd-close]');
  if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* -------------------------------------------------------------- views */
  function showView(name) {
    var found = false;
    views.forEach(function (v) {
      var match = v.getAttribute('data-zhd-view') === name;
      v.hidden = !match;
      if (match) found = true;
    });
    if (!found) return;

    // Only the five real sidebar destinations light up; "order" keeps Orders lit.
    var navName = name === 'order' ? 'orders' : name;
    navItems.forEach(function (n) {
      var isNav = n.classList.contains('zhd-nav-item');
      if (!isNav) return;
      var on = n.getAttribute('data-zhd-nav') === navName;
      n.classList.toggle('is-active', on);
      if (on) { n.setAttribute('aria-current', 'page'); } else { n.removeAttribute('aria-current'); }
    });

    var copy = COPY[name];
    if (copy && titleEl && subEl) { titleEl.textContent = copy[0]; subEl.textContent = copy[1]; }

    setDrawer(false);
    if (history.replaceState) history.replaceState(null, '', '#' + name);
    // Land at the top of the portal, not mid-panel.
    window.scrollTo({ top: Math.max(0, root.offsetTop - 60), behavior: 'smooth' });
  }

  navItems.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-zhd-nav');
      var prefill = btn.getAttribute('data-zhd-prefill');
      showView(target);
      if (prefill) preselectSupportOrder(prefill);
    });
  });

  /* ------------------------------------------------------- order detail */
  var detailPanels = root.querySelectorAll('[data-zhd-order-detail]');

  function openOrder(id) {
    var any = false;
    detailPanels.forEach(function (p) {
      var match = p.getAttribute('data-zhd-order-detail') === id;
      p.hidden = !match;
      if (match) any = true;
    });
    if (any) showView('order');
  }

  root.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-zhd-open-order]');
    if (!trigger) return;
    openOrder(trigger.getAttribute('data-zhd-open-order'));
  });

  /* --------------------------------------------- orders filter + search */
  var rows = root.querySelectorAll('[data-zhd-order-row]');
  var chips = root.querySelectorAll('[data-zhd-filter]');
  var searchInput = root.querySelector('[data-zhd-search]');
  var noResults = root.querySelector('[data-zhd-noresults]');
  var activeFilter = 'all';

  function applyFilters() {
    var term = (searchInput && searchInput.value || '').trim().toLowerCase();
    var visible = 0;
    rows.forEach(function (row) {
      var statusOk = activeFilter === 'all' || row.getAttribute('data-status') === activeFilter;
      var searchOk = !term || (row.getAttribute('data-search') || '').indexOf(term) !== -1;
      var show = statusOk && searchOk;
      row.hidden = !show;
      if (show) visible++;
    });
    if (noResults) noResults.hidden = visible !== 0 || rows.length === 0;
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      activeFilter = chip.getAttribute('data-zhd-filter');
      applyFilters();
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      applyFilters();
      // Typing in the header search is a request to look at the orders list.
      if (searchInput.value.trim()) showView('orders');
    });
  }

  /* ---------------------------------------------------------- support */
  function preselectSupportOrder(orderName) {
    var select = root.querySelector('[data-zhd-support-order]');
    if (!select) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === orderName) { select.selectedIndex = i; break; }
    }
  }

  /* ------------------------------------------------------------ share */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zhd-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share-url');
    var title = btn.getAttribute('data-share-title') || document.title;
    if (!url) return;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var done = function (ok) {
      var original = btn.getAttribute('data-original') || btn.innerHTML;
      btn.setAttribute('data-original', original);
      btn.textContent = ok ? 'Link copied' : 'Copy failed';
      setTimeout(function () { btn.innerHTML = original; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
    } else {
      done(false);
    }
  });

  /* ------------------------------------------------- open from the hash */
  var hash = (window.location.hash || '').replace('#', '');
  if (hash && COPY[hash]) {
    showView(hash);
  } else if (document.querySelector('.zhd-alert')) {
    // A submitted support form comes back with its result rendered — show it.
    showView('support');
  }

  applyFilters();
})();
